import { render } from "./cabinet-edit.vue?vue&type=template&id=46b12a51&scoped=true"
import script from "./cabinet-edit.vue?vue&type=script&lang=js"
export * from "./cabinet-edit.vue?vue&type=script&lang=js"

import "./cabinet-edit.vue?vue&type=style&index=0&id=46b12a51&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\YDN\\trunk\\zulin-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46b12a51"]])

export default __exports__